import styled from "styled-components";

export const OverlayFormSkeletonContainer = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  width: 100%;
`;
